import { useEffect } from "react";

const TWITTER_HANDLE = "DemolitionSmash";

export default function TwitterFeed({ showHeader = true }) {
  useEffect(() => {
    // Load Elfsight script if not already loaded
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="twitter-feed-container" data-testid="twitter-feed">
      {showHeader && (
        <div className="flex items-center justify-between mb-6">
          <a
            href={`https://x.com/${TWITTER_HANDLE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group"
          >
            <svg
              className="w-6 h-6 text-demolition-red"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
            <span className="font-teko text-lg text-white/70 group-hover:text-demolition-red transition-colors">
              @{TWITTER_HANDLE}
            </span>
          </a>
        </div>
      )}

      {/* Elfsight Twitter Feed Widget */}
      <div
        className="elfsight-app-aa166d80-9bf3-4344-b7de-7f7fd3238f83"
        data-elfsight-app-lazy
        data-testid="twitter-widget"
      />
    </div>
  );
}
